import React from "react";
import styled from "styled-components";
import TextField from "../../common/TextField";
import ResultMessageText from "../../common/ResultMessageText";
import {withRouter} from "react-router-dom";
import LoginContainer from './components/LoginContainer';
import ActionButton from "../../common/ActionButton";
import {SignIn} from "aws-amplify-react";
import {Auth} from "@aws-amplify/auth";

const ForgotPasswordLink = styled.a`
  margin-top: 1em;
  color: black;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;

  :hover {
    text-decoration: underline;
  }
`;

class LoginPage extends SignIn {

    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            confirmPassword: '',
            errorMessage: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    signUp = async () => {
        const {username, password, email, phone_number} = this.state;
        try {
            await Auth.signUp({username, password, attributes: {email, phone_number}})
        } catch (err) {
            console.log('error signing up user...', err)
        }
    };

    signIn = async () => {
        const {history} = this.props;
        const {email, password} = this.state;
        try {
            let user = await Auth.signIn(email, password);
            if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                this.props.onStateChange('requireNewPassword', user);
            } else {
                this.props.onStateChange('signedIn', user);
            }
            history.push('/');
        } catch (err) {
            if (err.code === 'UserNotConfirmedException') {
                this.props.onStateChange('requireNewPassword');
            } else if (err.code === 'PasswordResetRequiredException') {
                this.props.onStateChange('forgotPassword');
            } else if (err.code === 'NotAuthorizedException' || err.code === 'UserNotFoundException') {
                let errorMessage = 'Email or Password is incorrect. Please try again or reset your password.';
                this.setState({
                    errorMessage: errorMessage
                });
            }
        }
    };

    handleSubmit(event) {
        event.preventDefault();
        this.setState({
            errorMessage: ''
        });
        this.signIn();
    }

    onChange = event => {
        let target = event.target;
        this.setState({
            [target.id]: target.value
        });
    };

    showComponent(theme) {
        const {email, password, errorMessage} = this.state;
        return (
            <LoginContainer>
                <form onSubmit={this.handleSubmit}>
                    <TextField
                        className="mt-4"
                        id="email"
                        label="Email"
                        value={email}
                        valueChanged={this.onChange}
                        legacyMode={true}>
                    </TextField>
                    <TextField
                        className="mt-4"
                        id="password"
                        label="Password"
                        value={password}
                        valueChanged={this.onChange}
                        type="password"
                        legacyMode={true}>
                    </TextField>
                    <ActionButton
                        className="mt-4"
                        type="submit"
                        text="Sign In"/>
                </form>
                <ResultMessageText text={errorMessage} success={false}/>
                <ForgotPasswordLink onClick={(e) => this.props.onStateChange('forgotPassword')}>Forgot your
                    password?</ForgotPasswordLink>
            </LoginContainer>
        );
    }
}

export default withRouter(LoginPage);